import { Dropdown, MenuProps } from "antd";
import arrow from "@assets/arrow.svg";
import "./index.scss";
import { useEffect, useMemo, useState } from "react";
import { Popup } from "antd-mobile";
import { CheckOutline, CloseOutline } from "antd-mobile-icons";

type Props = {
  datas: any[];
  onChange: (value: string) => void;
  value: string;
};

export default function Index(props: Props) {
  const [text, setText] = useState<string>("");

  const [value, setValue] = useState<string>("");
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (props.value && props.datas) {
      const obj = props.datas.find((item: any) => {
        return item.value === props.value;
      });
      if (obj) {
        setText(obj.label);
      } else {
        setText(props.value);
      }
    }
  }, [props.value, props.datas]);

  useEffect(() => {
    if (visible) {
      setValue(props.value);
    }
  }, [props.value, visible]);

  const items: MenuProps["items"] = useMemo(() => {
    return props.datas.map((item) => {
      return {
        key: item.label,
        label: (
          <div
            className="dorpdownItem"
            onClick={() => {
              props.onChange(item.value);
            }}
          >
            {item.label}
          </div>
        ),
      };
    });
  }, [props.datas]);

  const isMobile: any = localStorage.getItem("isMobile");

  if (isMobile == 1) {
    return (
      <>
        <div
          className="dropdownContainer"
          onClick={() => {
            setVisible(true);
          }}
        >
          {text} <img src={arrow} />
        </div>

        {/* <Picker
        className="h5Picker"
        columns={[props.datas]}
        visible={visible}
        confirmText="Confirm"
        cancelText="Cancel"
        onClose={() => {
          setVisible(false)
        }}
        value={[props.value]}
        onConfirm={(v:any) => {
          props.onChange(v[0])
        }}
      /> */}
        <Popup
          visible={visible}
          onMaskClick={() => {
            setVisible(false);
          }}
          className="dropdownPopup"
          bodyStyle={{ height: "50vh" }}
        >
          <div className="dropdownPopupContainer">
            {/* <div className="popuphead">
            <CloseOutline style={{ fontSize: "0.28rem" }} onClick={() => {
              setVisible(false)
            }} /> 
          </div> */}

            {/* <div className="popupbody">

            {props.datas.map((item) => {
              return <div className="body-item" onClick={() => {
                setValue(item.value)
              }}>
                <label>{item.label}</label>
                {item.value == value && <CheckOutline />}
              </div>
            })}
          </div> */}
            <div className="popupbody">
              {props.datas.map((item) => {
                return (
                  <div
                    className="body-item"
                    onClick={() => {
                      props.onChange(item.value);
                      setVisible(false);
                    }}
                  >
                    <label>{item.label}</label>
                  </div>
                );
              })}
            </div>
            {/* <div className="popupfooter">
            <div className="btn" onClick={()=>{
                props.onChange(value);
                setVisible(false)
            }}>
              confirm
            </div>
          </div> */}
          </div>
        </Popup>
      </>
    );
  } else {
    return (
      <Dropdown
        menu={{ items }}
        overlayClassName="dropdownOverlay"
        placement="bottom"
        trigger={["click"]}
      >
        <div className="dropdownContainer">
          {text} <img src={arrow} />
        </div>
      </Dropdown>
    );
  }
}
